import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC, useContext } from "react";
import { css } from "styled-components";
export interface OrderDateStyles {
    wrapper?: GridItemProps;
    titleText?: TypographyProps;
    orderDate?: TypographyProps;
}

export const orderDateStyles: OrderDateStyles = {
    wrapper: {        
        css: css`
            padding-bottom: 10px;
        `,
    },
    titleText: {
        variant: "h3",
        css: css`
            @media print {
                font-size: 12px;
            }
            margin-bottom: 5px;
            font-size: 16px;
        `,
    },
};

const styles = orderDateStyles;

const OrderUserName: FC = () => {
    const { value: order } = useContext(OrderStateContext);
    if (!order || !order.terms) {
        return null;
    }  
    return (
        <>
    <GridItem {...styles.wrapper}>     
     <Typography {...styles.orderDate} aria-labelledby="orderUser" data-test-selector="orderUser">
       <strong> {translate("User Name")}</strong>: {order?.terms}
     </Typography>
   </GridItem>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: OrderUserName,
    definition: {
        allowedContexts: ["OrderDetailsPage", "VmiOrderDetailsPage"],
        group: "Order Details",
    },
};

export default widgetModule;
